export type Discipline = "web" | "app" | "dashboard" | "ai";

export interface Project {
  title: string;
  description: string;
  discipline: Discipline;
  tags: string[];
  link: string;
  thumbnail: string;
  year?: string;
}

export const disciplines: {
  id: Discipline;
  label: string;
  blurb: string;
}[] = [
  {
    id: "web",
    label: "אתרים ואתרי תדמית",
    blurb:
      "אתרים שנבנים מאפס ב-React ו-Next.js. מהירים, מדורגים גבוה בגוגל, ומייצרים פניות.",
  },
  {
    id: "app",
    label: "אפליקציות מובייל",
    blurb:
      "אפליקציות iOS ואנדרואיד שיצאו לחנויות, מהאפיון ועד ההגשה והתחזוקה השוטפת.",
  },
  {
    id: "dashboard",
    label: "דשבורדים, Big Data ודוחות אנליטיקה",
    blurb:
      "בניית דשבורדים, עיבוד מאגרי נתונים גדולים ודוחות אנליטיקה. דאטה גולמי נכנס בצד אחד, החלטה ברורה יוצאת בצד השני.",
  },
  {
    id: "ai",
    label: "כלי AI וניתוח נתונים",
    blurb:
      "סוכנים אוטונומיים, RAG על מאגרי מידע פנימיים, וחיפוש סמנטי בסקייל.",
  },
];

export const projects: Project[] = [
  /* ---------------------------------------------------------------- web -- */
  {
    title: "שני ברנשטיין · אדריכלות ועיצוב פנים",
    description:
      "אתר לאדריכלית ומעצבת פנים שבמרכזו מנוע סיור תלת-ממדי. לכל אחד משבעת הפרויקטים נבנה חלל אינטראקטיבי לפי החומריות, הפרופורציות והתאורה של הפרויקט עצמו: מעבר בין תאורת יום וערב, מצלמה שנעה בגלילה, סיור חופשי, ונקודות ציון שלחיצה עליהן פותחת את התצלום האמיתי מאותה נקודה בחלל. נכנסים לחלל, לא רק מסתכלים בתמונה.",
    discipline: "web",
    tags: ["3D Tour", "אדריכלות", "אינטראקטיבי"],
    link: "https://shaniarc-studio.vercel.app/",
    thumbnail: "/images/work/shaniarc.jpg",
  },
  {
    title: "משרד עו״ד יניב גיל ושות'",
    description:
      "אתר תדמית למשרד עורכי דין מוביל בדיני משפחה. עיצוב אלגנטי ורציני, ביצועים מהירים וקידום אורגני שמביא את המשרד לעמוד הראשון בגוגל בביטויי דיני משפחה במחוז המרכז.",
    discipline: "web",
    tags: ["Next.js", "SEO", "תדמית"],
    link: "https://www.yanivgil.co.il",
    thumbnail: "/images/work/yanivgil.jpg",
  },
  {
    title: "עו״ד מורן בריק מילר",
    description:
      "אתר תדמית לעורכת דין ומגשרת בדיני משפחה עם מעל 25 שנות ניסיון. מבנה תוכן שמסביר תחומי ייצוג מורכבים בשפה ברורה, ומסלול פנייה קצר לכל עמוד.",
    discipline: "web",
    tags: ["Next.js", "SEO", "משפט"],
    link: "https://www.brikmiller.co.il",
    thumbnail: "/images/work/brikmiller.jpg",
  },
  {
    title: "Homie Finance · ייעוץ משכנתאות",
    description:
      "אתר לחברת ייעוץ משכנתאות ופיננסים. מחשבוני משכנתא אינטראקטיביים, השוואת מסלולים ותהליך פנייה שמייצר לידים איכותיים, מחובר למעקב המרות מלא.",
    discipline: "web",
    tags: ["משכנתאות", "לידים", "GA4"],
    link: "https://www.homie-finance.com",
    thumbnail: "/images/work/homie.jpg",
  },
  {
    title: "Cohorta AI",
    description:
      "אתר מוצר לחברת בינה רפואית שהופכת מסעות מטופלים לתובנות בריאות מהעולם האמיתי. אנגלית ועברית, שפה ויזואלית שקטה שמתאימה לקהל רפואי ומשקיעים.",
    discipline: "web",
    tags: ["Product", "בינלאומי", "Health"],
    link: "https://www.cohorta-ai.com",
    thumbnail: "/images/work/cohorta.jpg",
  },
  {
    title: "SAPIRIO HOME · הדמיית מצעים ב-AI",
    description:
      "משפך מכירה שבו הלקוח מעלה תמונה של חדר השינה שלו ורואה את מצעי היוקרה עליה. אותו חדר, אותו אור, רק המצעים מתחלפים. עיצוב, פיתוח, וחיבור מלא לקמפיינים.",
    discipline: "web",
    tags: ["E-commerce", "AI", "משפך"],
    link: "https://sapir-xi.vercel.app",
    thumbnail: "/images/work/sapirio.jpg",
  },
  {
    title: "Idan Locations · סוכנות לוקיישנים",
    description:
      "פלטפורמת סקאוטינג להפקות צילום וקולנוע. קטלוג לוקיישנים עם חיפוש וסינון מתקדם, גלריות תמונות ומערכת ניהול הזמנות.",
    discipline: "web",
    tags: ["קטלוג", "חיפוש", "הפקות"],
    link: "https://idanlocations.com",
    thumbnail: "/images/work/idanlocations.jpg",
  },
  {
    title: "מוריה שלום · מותג אופנת נשים",
    description:
      "אתר למותג אופנת נשים מתל אביב שפועל מ-2015. דו-לשוני עברית ואנגלית, עם קולקציות, עמוד אטלייה, יומן ומסלול פנייה למדידות אישיות והזמנות מיוחדות. שפה ויזואלית שחור-לבן שנותנת לבגד להוביל.",
    discipline: "web",
    tags: ["Next.js", "אופנה", "דו-לשוני"],
    link: "https://moriyashalom.com",
    thumbnail: "/images/work/moriyashalom.jpg",
  },
  {
    title: "אמטיסט · יבוא חומרים לתעשייה",
    description:
      "אתר תדמית לחברת יבוא בינלאומית המתמחה בחומרים כימיים מיוחדים לתעשיית הבנייה. קטלוג מוצרים מקצועי, מפרטים טכניים ואתר שמשדר אמינות.",
    discipline: "web",
    tags: ["תעשייה", "B2B", "קטלוג"],
    link: "https://amatist.vercel.app",
    thumbnail: "/images/work/amatist.jpg",
  },
  {
    title: "אלעד קרן · האתר הרשמי",
    description:
      "אתר הספר של אלעד קרן, בנוי מאפס ב-Next.js. עמוד נחיתה קולנועי עם טיפוגרפיה עברית גדולה, קטעים מהספר, קליפים ומכירה ישירה.",
    discipline: "web",
    tags: ["Next.js", "ספר", "אישי"],
    link: "https://eladkeren.vercel.app",
    thumbnail: "/images/work/eladkeren.jpg",
  },

  /* ---------------------------------------------------------------- app -- */
  {
    title: "אות-אות · לימוד קריאה וחשבון לילדים",
    description:
      "אפליקציית לימוד לכיתות א׳ עד ו׳: סיפורים מנוקדים בניקוד מדויק, תרגול קריאה והבנת הנקרא, אימון כתיבה ועולם חשבון והנדסה עם הסברים מונפשים. חיית מחמד וירטואלית שגדלה עם כל תרגול.",
    discipline: "app",
    tags: ["iOS", "Android", "חינוך"],
    link: "https://www.otot.app",
    thumbnail: "/images/work/otot.jpg",
  },
  {
    title: "Along · אפליקציית ליווי למטופלים",
    description:
      "אפליקציית מובייל למטופלי CLL מבית Cohorta AI. מלווה את המטופל לאורך המסע הרפואי, מתעדת תסמינים ומחזירה תמונת מצב ברורה בלי להעמיס.",
    discipline: "app",
    tags: ["Health", "מובייל", "Product"],
    link: "https://along.cohorta-ai.com",
    thumbnail: "/images/work/along.jpg",
  },
  {
    title: "iSyncU · תזמון וקולבורציה להרכבים",
    description:
      "אפליקציה למוזיקאים ולהקות: סנכרון לוחות זמנים של חברי ההרכב, התאמה בין נגנים, הזמנת חדרי חזרה ואולפן, ותזכורות אוטומטיות. הרעיון, האפיון והפיתוח שלנו.",
    discipline: "app",
    tags: ["Web App", "מוזיקה", "AI"],
    link: "https://isyncu.net",
    thumbnail: "/images/work/isyncu.jpg",
  },
  {
    title: "Match-Match · אפליקציית הכרויות",
    description:
      "פלטפורמת הכרויות מבוססת AI למציאת התאמות מדויקות. פרופילים מאומתים, אירועי ספיד דייטינג ומנוע התאמה חכם.",
    discipline: "app",
    tags: ["AI", "React Native", "הכרויות"],
    link: "https://match-match-gamma.vercel.app",
    thumbnail: "/images/work/matchmatch.jpg",
  },

  /* ---------------------------------------------------------- dashboard -- */
  {
    title: "מחולל דוחות אנליטיקה מבוסס ראיות",
    description:
      "מערכת ארגונית שמקבלת ראיות גולמיות (PDF, CSV, צילומי דשבורד) ומייצרת דוח לקוח מוכן שכל טענה בו נסמכת על המקור שהועלה. בצילום: דוח אמיתי שהמערכת הפיקה, כולל תמונת מצב להנהלה, טבלאות לפי אתר וסימון חומרה לכל ממצא. כל המזהים הוסרו.",
    discipline: "dashboard",
    tags: ["React", "BI", "AI"],
    link: "",
    thumbnail: "/images/work/reports-sample.jpg",
  },
  {
    title: "Cohorta SignalMap · דשבורד תובנות",
    description:
      "דשבורד ניתוח למסעות מטופלים: אגרגציה אנונימית, זיהוי מגמות וחריגות, ותצוגה שמאפשרת לצוות רפואי לקרוא מצב בשנייה במקום בדוח.",
    discipline: "dashboard",
    tags: ["Dashboard", "Data Viz", "Health"],
    link: "https://www.cohorta-ai.com/insights",
    thumbnail: "/images/work/cohortadash.jpg",
  },
  {
    title: "ניטור תשתיות רשת בשטח",
    description:
      "ממשק מובייל לצוותי תפעול רשת: מצב אתרים, התראות וסטטוס ציוד בזמן אמת, בנוי לטכנאי שעומד מול ארון תקשורת ולא מול מסך 27 אינץ׳. פרויקט סגור, מוצג ללא שם הלקוח.",
    discipline: "dashboard",
    tags: ["ניטור", "מובייל", "Ops"],
    link: "",
    thumbnail: "",
  },

  /* ----------------------------------------------------------------- ai -- */
  {
    title: "Growth OS · מערכת צמיחה אוטונומית",
    description:
      "המערכת שאנחנו מריצים על הלקוחות שלנו. סוכנים שאוספים דאטה אמיתי מגוגל, מזהים הזדמנות, מבצעים פעולה, מודדים תוצאה ולומדים ממנה. כל מספר במערכת נסמך על ראיה, לא על הערכה. בצילום: הדשבורד התפעולי עצמו, שמות הלקוחות מוסתרים.",
    discipline: "ai",
    tags: ["AI Agents", "SEO", "אוטומציה"],
    link: "/growth-os",
    thumbnail: "/images/work/growthos.jpg",
  },
  {
    title: "PicLocate · חיפוש תמונות סמנטי",
    description:
      "מנוע חיפוש תמונות מבוסס AI: חיפוש בשפה טבעית, חיפוש הפוך, אינדוקס מלא של ספריות ענק וחיבור ל-Google Drive. נבנה לצוותי הפקה שמחפשים פריים אחד מתוך מאות אלפים, ומשמש כמנוע הסקאוטינג של Idan Locations.",
    discipline: "ai",
    tags: ["AI", "Vision", "Big Data"],
    link: "https://pic-locate.vercel.app",
    thumbnail: "/images/work/piclocate.jpg",
  },
  {
    title: "נאמן Coach · מאמן בחינות קולי",
    description:
      "מאמן קולי בעברית להכנה לבחינת נאמנים בחדלות פירעון. RAG על מקורות החוק, תשובות עם הפניה למקור, ומחוון ניקוד שמעניש הזיות. שיחה, לא שאלון.",
    discipline: "ai",
    tags: ["Voice AI", "RAG", "משפט"],
    link: "https://naman-coach.vercel.app",
    thumbnail: "/images/work/namancoach.jpg",
  },
];

export const projectsByDiscipline = (id: Discipline) =>
  projects.filter((p) => p.discipline === id);
